<template>
    <div class="bs-page">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.bs-page {
    padding: 1.5rem;
}
</style>